/**
 * Универсальные форматтеры для дат и валют (GEL).
 *
 * Источник реализации: apps/admin/src/lib/orders.ts (более полный набор
 * со включением года и времени) — он покрывает кейсы клиента (короткая дата
 * "DD MMM") и admin'а (длинная дата с годом, дата-время).
 */
/** Короткая дата "01 янв" — формат, использовавшийся в Mini App клиенте. */
export function formatDateShort(iso) {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    return d.toLocaleDateString("ru-RU", { day: "2-digit", month: "short" });
}
/** Полная дата "01 янв 2025" — формат admin-панели. */
export function formatDate(iso) {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    return d.toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
}
/** "01 янв, 14:30" — для логов статусов и таблиц admin. */
export function formatDateTime(iso) {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    return d.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
    });
}
/**
 * Форматирует сумму в лари. `null`/`undefined` → "—" (пусто). Округляем до
 * целых — клиент платит наличкой/безналом без копеек.
 */
export function formatGel(v) {
    if (v == null)
        return "—";
    return `${Math.round(v)} GEL`;
}
/** Короткий человекочитаемый ID — первые 8 символов uuid в верхнем регистре. */
export function shortId(id) {
    return id.slice(0, 8).toUpperCase();
}
//# sourceMappingURL=index.js.map